import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import positions from '../../db/positions.json';

import Header from '../Header';

const PositionDetail = () => {
	let position;
	const slug = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
	// eslint-disable-next-line array-callback-return
	positions.map(pos => {
		if (pos.slug === slug) {
			position = pos;
		}
	});

	const { topicStyle, titleStyle, headerStyle, footerStyle } = styles;

	const renderList = (title, content) => {
		return (
			<div className="col-sm-12">
				<span style={topicStyle}>{title}</span>
				<ul>
					{content.map(activity => (
						<li key={activity}>{activity}</li>
					))}
				</ul>
			</div>
		);
	};

	return (
		<Fragment>
			<Header />
			<div className="row" style={{ marginTop: "30px"}}>
				<div className="col-sm-12">
					<Link id="positions-link" to="/positions">All open positions</Link>
				</div>
			</div>
			<br />
			<div className="row">
				<div className="col-sm-12" style={headerStyle}>
					<h3 style={titleStyle}>{position.title}</h3>
					<h5>{position.subtitle}</h5>
				</div>
				{renderList("What you'll do", position.activities)}
				{renderList('What we need you to have', position.skills)}
				{renderList("It'd be awesome if you", position.desired)}
				<div className="col-sm-12">
					<span style={topicStyle}>What we offer:</span>
					<ul>
						<li>Full time contract (CLT)</li>
						<li>
							Fast-paced environment of an early-stage startup
						</li>
						<li>
							Huge responsibilities, independently of your
							hierarchical level of the position you’re at
						</li>
						<li>An amazing and high performing team</li>
						<li>Be recognized by your work and accomplishments</li>
						<li>
							A fun and exciting working environment for growing
							in your career
						</li>
					</ul>
				</div>
			</div>
			<div className="row" style={footerStyle}>
				<div className="col-sm-12 text-center">
					<strong>
						To apply to this position, send your cover letter and CV
						to hello@anthor.com.br
					</strong>
				</div>
			</div>
		</Fragment>
	);
};

const styles = {
	footerStyle: {
		marginTop: '50px',
		marginBottom: '50px'
	},
	titleStyle: {
		fontSize: '1.8em'
	},
	topicStyle: {
		color: '#749b08',
		fontSize: '1.4em'
	}
};

export default PositionDetail;
